import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_391: DocMigration = {
  maxSchemaVersion: "0.0.391",
  description: "Fix missing WallAssemblyOverride disabled field",
  apply(json: any) {
    for (const overrideId in json.edgeBehaviors) {
      const override = json.edgeBehaviors[overrideId];
      if (override.edgeBehaviorType === "WALL_ASSEMBLY") {
        const { wallAssemblyOperator } = override;
        if (wallAssemblyOperator.operationType !== "OFFSET") {
          const { layer } = wallAssemblyOperator;
          if (layer.disabled !== undefined) {
            override.disabled = layer.disabled;
            delete layer.disabled;
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_391;
